{
  "title": "Parc produits",
  "subtitle": "Liste des produits rattachés à vos entreprises.",
  "search": "Rechercher un produit",
  "tabs": {
    "allProducts": "Tous les produits",
    "epi": "EPI",
    "nonEpi": "Outillage",
    "requests": "Demandes"
  },
  "kpis": {
    "activeProducts": "Produits actifs",
    "averageUsage": "Durée moyenne d'usage",
    "pendingRequests": "Demandes en attente",
    "acceptedNameplates": "Produits acceptées"
  },
  "duration": {
    "day": "{value} jour",
    "days": "{value} jours",
    "month": "{value} mois",
    "months": "{value} mois",
    "year": "{value} an",
    "years": "{value} ans"
  },
  "table": {
    "photo": "Photo",
    "name": "Nom",
    "team": "Équipe",
    "serialNumber": "Numéro de série",
    "operatingCenter": "Entreprise",
    "usageStart": "Date de début d'utilisation",
    "usageDuration": "Durée usage",
    "repair": "Réparer",
    "control": "Contrôler"
  },
  "detail": {
    "title": "Détail du parc produit",
    "subtitle": "{productName} - {boomerangId}",
    "pictureAlt": "Image produit",
    "sections": {
      "productScope": "Périmètre produit",
      "usage": "Informations d'usage",
      "attachments": "Pièces jointes"
    },
    "labels": {
      "boomerangId": "Identifiant parc",
      "customerInvoiceId": "Identifiant facture client",
      "keyAccountNetwork": "Réseau grand compte",
      "operatingCenter": "Centre d'exploitation",
      "distributorNetwork": "Réseau distributeur",
      "store": "Magasin",
      "manufacturer": "Fabricant",
      "category": "Catégorie",
      "subCategory": "Sous-catégorie",
      "product": "Produit",
      "allocationCode": "Code d'imputation",
      "companyName": "Entreprise",
      "teamName": "Équipe",
      "purchaseDate": "Date d'achat",
      "usageStartDate": "Date de début d'utilisation",
      "manufacturingDate": "Date de fabrication",
      "serialNumber": "Nº de série",
      "usageDuration": "Durée d'usage"
    },
    "buttons": {
      "nameplateAttachment": "Ouvrir la plaque signalétique",
      "purchaseInvoiceAttachment": "Ouvrir la facture d'achat",
      "addPurchaseInvoice": "Ajouter la facture d'achat"
    },
    "actions": {
      "repair": "Réparer"
    },
    "messages": {
      "updateSuccess": "Produit mis à jour.",
      "purchaseInvoiceUpdateSuccess": "Facture d'achat ajoutée."
    },
    "purchaseInvoiceModal": {
      "title": "Ajouter la facture d'achat",
      "validate": "Ajouter la facture"
    }
  },
  "requestList": {
    "search": "Rechercher une demande",
    "statusFilter": "Statut",
    "reference": "REQ-{id}",
    "table": {
      "reference": "Référence",
      "operatingCenter": "Entreprise",
      "requester": "Demandeur",
      "nameplateCount": "Plaques",
      "status": "Statut",
      "createdAt": "Créée le"
    },
    "status": {
      "all": "Tous les statuts",
      "DRAFT": "Brouillon",
      "PENDING": "En attente",
      "AWAITING_INFORMATION": "En attente d’informations",
      "APPROVED": "Approuvée",
      "DENIED": "Refusée"
    },
    "deleteModal": {
      "title": "Supprimer le brouillon",
      "message": "Voulez-vous vraiment supprimer cette demande brouillon ? Cette action est irréversible."
    },
    "messages": {
      "deleteSuccess": "Brouillon supprimé."
    }
  },
  "requestDetail": {
    "title": "Détail de la demande",
    "subtitle": "Demande de création REQ-{id}",
    "sections": {
      "request": "Informations de la demande",
      "scope": "Informations de rattachement",
      "attachments": "Pièces jointes"
    },
    "labels": {
      "reference": "Référence",
      "status": "Statut",
      "createdAt": "Créée le",
      "reviewedAt": "Traitée le",
      "keyAccountNetwork": "Réseau grand compte",
      "operatingCenter": "Centre d'exploitation",
      "requester": "Demandeur",
      "nameplateCount": "Plaques",
      "purchaseInvoice": "Facture d'achat",
      "nameplates": "Fichiers de plaques"
    }
  },
  "requestDraft": {
    "title": "Nouvelle demande de création",
    "editTitle": "Reprendre la demande",
    "publicTitle": "Continuer la demande",
    "subtitle": "Déposez la facture d'achat et les plaques signalétiques des produits à référencer",
    "operatingCenter": {
      "title": "Informations de rattachement",
      "subtitle": "Sélectionnez le centre d'exploitation concerné par cette demande.",
      "field": "Centre d'exploitation",
      "placeholder": "Sélectionner un centre d'exploitation"
    },
    "invoice": {
      "title": "Facture d'achat",
      "subtitle": "Un seul fichier - PDF ou image",
      "dropzoneTitle": "Cliquez ou déposez votre facture",
      "acceptedFormats": "PDF, JPG, PNG, WEBP"
    },
    "nameplates": {
      "title": "Plaques signalétiques",
      "subtitle": "Une plaque = un produit à créer (au moins 1)",
      "dropzoneTitle": "Ajoutez une ou plusieurs plaques",
      "acceptedFormats": "JPG, PNG, WEBP, HEIC - vous pouvez sélectionner plusieurs fichiers"
    },
    "dropzone": {
      "dragHere": "Déposez votre fichier ici",
      "or": "ou ",
      "browse": "parcourez vos fichiers",
      "acceptedFormats": "Formats acceptés"
    },
    "actions": {
      "add": "Ajouter",
      "addFromPhone": "Ajouter depuis un téléphone",
      "create": "Nouvelle demande",
      "remove": "Supprimer",
      "share": "Partager à un collaborateur",
      "sendFromMobile": "Envoyer depuis mobile",
      "takePhoto": "Prendre une photo",
      "submit": "Finaliser la demande"
    },
    "footer": {
      "invoice": "Facture d'achat",
      "nameplates": "{count} plaque(s) signalétique(s)",
      "nameplatesReady": "{count} plaque(s) prête(s) à être envoyée(s)"
    },
    "messages": {
      "createSuccess": "Demande de création envoyée."
    },
    "publicConfirmation": {
      "title": "Demande envoyée",
      "subtitle": "Le formulaire a bien été envoyé. Vous pouvez fermer cette page."
    },
    "mobileUpload": {
      "title": "Ajouter depuis un téléphone",
      "subtitle": "Scannez ce QR code avec votre téléphone pour ajouter une ou plusieurs plaques signalétiques.",
      "help": "Prenez une photo ou ajoutez les fichiers depuis votre téléphone, puis revenez sur cet écran pour confirmer l'ajout.",
      "confirm": "J'ai ajouté la plaque signalétique depuis mon téléphone",
      "missing": "Aucune nouvelle plaque signalétique n'a encore été ajoutée depuis le téléphone.",
      "publicTitle": "Ajouter des plaques signalétiques",
      "publicSubtitle": "Prenez une photo ou ajoutez une ou plusieurs plaques signalétiques depuis votre téléphone.",
      "publicSubmit": "Ajouter les plaques",
      "successTitle": "Plaques ajoutées",
      "successSubtitle": "Les plaques signalétiques ont bien été ajoutées. Vous pouvez reprendre la demande sur l'ordinateur."
    },
    "share": {
      "title": "Partager le formulaire",
      "subtitle": "Envoyez ce formulaire à quelqu'un pour qu'il le remplisse à votre place.",
      "scanTitle": "Scanner avec un mobile",
      "scanHelp": "Ouvre directement le formulaire sur le téléphone.",
      "copyTitle": "Copier le lien",
      "emailTitle": "Envoyer par email",
      "smsTitle": "Envoyer par SMS",
      "linkLabel": "Lien de reprise",
      "copySuccess": "Lien copié.",
      "copyError": "Impossible de copier le lien.",
      "emailLabel": "Adresse email",
      "emailPlaceholder": "Adresse email",
      "emailButton": "Envoyer",
      "emailSuccess": "Lien envoyé par email.",
      "emailError": "Impossible d'envoyer l'email.",
      "smsLabel": "Téléphone",
      "smsPlaceholder": "Téléphone",
      "smsButton": "Envoyer",
      "smsSuccess": "Lien envoyé par SMS.",
      "smsError": "Impossible d'envoyer le SMS."
    }
  }
}
